<div class="min-h-80vh p-10">
  <div class="max-w-6xl mx-auto">
    <div
      class="bg-white rounded-2xl border border-gray-200 p-8 mb-8 flex items-center justify-between"
    >
      <div>
        <h1 class="text-3xl font-bold text-gray-800">
          Panel de Administración
        </h1>
        <p class="text-gray-600 mt-2">
          Bienvenido,
          <span class="font-semibold">Administrador de Codijobs</span>. Gestiona
          compañías, usuarios y el control general de la plataforma.
        </p>
      </div>
      <img src="assets/icon/codijobs.png" alt="Codijobs" class="w-20 h-20" />
    </div>
    <div>
      <h2 class="text-xl font-semibold text-gray-700 mb-4">Opciones rápidas</h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div
          class="bg-red-50 border border-red-100 rounded-xl shadow-sm hover:shadow-md transition transform hover:scale-105 duration-200 cursor-pointer p-4 flex flex-col items-center justify-center text-center hover:bg-red-100"
          (click)="openDeleteModal()"
        >
          <div
            class="text-red-600 p-3 rounded-full mb-3 transition-all duration-200"
          >
            <ng-icon name="heroTrash" size="30"></ng-icon>
          </div>
          <h3 class="text-base font-semibold text-gray-800 mb-1">
            Eliminar compañías no verificadas
          </h3>
          <p class="text-xs text-gray-500 leading-tight">
            Elimina todas las compañías que aún no han sido verificadas.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="showConfirmDelete"
    class="fixed inset-0 bg-black/70 bg-opacity-40 flex items-center justify-center z-50"
  >
    <div
      class="bg-white rounded-xl shadow-lg p-6 w-80 sm:w-96 text-center relative animate-fade-in"
    >
      <h2 class="text-lg font-semibold text-gray-800 mb-2">
        ¿Eliminar compañías no verificadas?
      </h2>
      <p class="text-gray-600 text-sm mb-6">
        Esta acción eliminará
        <span class="font-semibold text-red-500">todas</span> las compañías que
        aún no estén verificadas. ¿Deseas continuar?
      </p>

      <div class="flex justify-center gap-3">
        <button
          (click)="closeDeleteModal()"
          class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
        >
          Cancelar
        </button>
        <app-loading-button
          [text]="'Eliminar'"
          [loading]="loadingDelete"
          type="button"
          (click)="confirmDelete()"
        >
        </app-loading-button>
      </div>
    </div>
  </div>
</div>
